import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useShare } from '../context/ShareContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingChat = () => {
  const { user, unreadCount } = useShare();
  const location = useLocation();

  // Don't show on chat page or for guests
  if (!user || location.pathname === '/chat' || location.pathname === '/auth') return null;

  return (
    <div className="fixed bottom-6 right-6 z-40">
      <Link to="/chat">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="relative group"
        >
          {/* Unread Badge */}
          <AnimatePresence>
            {unreadCount > 0 && (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
                className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] font-black w-6 h-6 rounded-full flex items-center justify-center shadow-lg z-10 border-2 border-white"
              >
                {unreadCount}
              </motion.div>
            )}
          </AnimatePresence>

          {/* Main Bubble */}
          <div className={`w-14 h-14 rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 ${unreadCount > 0 ? 'bg-emerald-600 animate-bounce' : 'bg-gray-900 group-hover:bg-emerald-600'}`}>
            <SafeIcon icon={FiIcons.FiMessageCircle} className="text-white text-2xl" />
          </div>

          {/* Tooltip */}
          <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-[10px] font-bold px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none shadow-xl">
            {unreadCount > 0 ? `${unreadCount} neue Nachricht${unreadCount > 1 ? 'en' : ''}` : 'Zum Chat'}
          </div>
        </motion.div>
      </Link>
    </div>
  );
};

export default FloatingChat;
